import { render, staticRenderFns } from "./URadioButton.vue?vue&type=template&id=34aa2a99&scoped=true&"
import script from "./URadioButton.vue?vue&type=script&lang=js&"
export * from "./URadioButton.vue?vue&type=script&lang=js&"
import style0 from "./URadioButton.vue?vue&type=style&index=0&id=34aa2a99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa2a99",
  null
  
)

export default component.exports